import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { launchOffer } from '../data/content';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 900);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-231" data-mp="3ud545iqzlsr7">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} transition={{
      duration: 0.2,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-night-line bg-night/95 px-4 py-3 backdrop-blur" data-id="element-232" data-mp="3ubu2boh3qv2q">
          <div className="mx-auto flex max-w-content items-center justify-between gap-4" data-id="element-233" data-mp="gxpcd00e1b3z">
            <div className="hidden sm:block" data-id="element-234" data-mp="gzjuy7o6sr4w">
              <p className="font-sans text-sm font-semibold text-parchment" data-id="element-235" data-mp="76xe2cos0w69">
                GPS Bíblico completo · 73 mapas + 2 bonos
              </p>
              <p className="font-sans text-xs text-parchment/55" data-id="element-236" data-mp="gvp1q8mt0ubd">
                <span className="line-through" data-id="element-237" data-mp="gx9zs88buvdz">{launchOffer.regularPrice}</span> hoy{' '}
                <span className="font-semibold text-gold-soft" data-id="element-238" data-mp="c473hsc617u3">{launchOffer.price}</span>
              </p>
            </div>
            <CtaButton size="block" className="sm:w-auto sm:px-8" data-id="element-239" data-mp="pyghgkmpqc8t">
              🙏 Quiero acceder — {launchOffer.price}
            </CtaButton>
          </div>
        </motion.div>}
    </AnimatePresence>;
}